import { DatePicker } from "antd";
import { CaretDownFilled, CaretUpOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useAdmin } from "../../context/adminContext";

const SearchDatePicker = ({ title, fieldName, width = 260 }) => {
  const { searchFields, setSearchFields, showFilter } = useAdmin();
  const valueChange = (e) => {
    var query = { ...searchFields };
    if (e == null) {
      query[fieldName] = null;
      return setSearchFields(query);
    }
    if (!e || e.length !== 2) return;

    var dates = [dayjs(e[0]).startOf("day"), dayjs(e[1]).endOf("day")];
    query[fieldName] = dates;
    setSearchFields(query);
  };
  const sortChange = (sort) => {
    setSearchFields({ ...searchFields, sort: sort, sortField: fieldName });
  };
  return (
    <div
      key={fieldName}
      className="table-search-field"
      style={{ minWidth: width, width: "100%" }}
    >
      <div className="titleWithSort">
        <span className="table-search-field__title">{title}</span>
        <div className="sortIcons">
          <CaretUpOutlined
            className="sortIcon"
            style={{ color: "#46CE7C" }}
            onClick={() => sortChange("asc")}
          />
          <CaretDownFilled
            className="sortIcon"
            style={{ color: "#46CE7C" }}
            onClick={() => sortChange("desc")}
          />
        </div>
      </div>
      {showFilter && (
        <>
          <div className="line" />
          <div className="table-search-field__input-wrap">
            <DatePicker.RangePicker
              size="middle"
              allowClear
              style={{ width: "100%", minWidth: width }}
              placeholder={["Эхлэх", "Дуусах"]}
              value={searchFields && searchFields[fieldName]}
              onChange={valueChange}
            />
          </div>
        </>
      )}
    </div>
  );
};
export default SearchDatePicker;
